import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-limit-to',
	templateUrl: './limit-to.component.html',
	styleUrl: './limit-to.component.css'
})
export class LimitToComponent {
	@Input() text: any = "";
	@Input() limit: any = "20";
}
